import React from 'react';
import { TextField } from '@mui/material';

interface ShortTextFieldProps {
  value: string | null;
  onChange: (value: string | null) => void;
  autoFocus?: boolean;
  disabled?: boolean;
}

const ShortTextField: React.FC<ShortTextFieldProps> = ({ value, onChange, autoFocus, disabled }) => {
  return (
    <TextField
      variant="standard"
      fullWidth
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      autoFocus={autoFocus}
      disabled={disabled}
      sx={{
        '& .MuiInput-root': {
          fontSize: '1.25rem',
        },
        '& .MuiInput-input': {
          textAlign: 'center',
          py: 0.5,
        },
      }}
    />
  );
};

export default ShortTextField;
